class StoreStatus extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.dotElement = this.querySelector('.wq-footer-stores__dot');
    this.textElement = this.querySelector('.wq-footer-stores__status-text');
    if (!this.dotElement || !this.textElement) return;

    const { weekDays, hours, dayHours, closedDates } = this.dataset;
    this.openWeekDays = (weekDays || '').split(',').map((weekDay) => parseInt(weekDay, 10));
    this.openingRanges = (hours || '').split(',').filter(Boolean).map(this.parseRange).filter(Boolean);

    // Hours set day by day: "1=09:00-12:00,14:00-18:00;2=..." (0 is Sunday)
    this.dayRanges = new Map(
      (dayHours || '').split(';').filter(Boolean).map((entry) => {
        const [weekDay, ranges] = entry.split('=');
        return [parseInt(weekDay, 10), (ranges || '').split(',').filter(Boolean).map(this.parseRange).filter(Boolean)];
      })
    );
    this.closedDates = (closedDates || '').split(',').filter(Boolean);

    this.render();
    this.refreshInterval = setInterval(this.render, 60000);
  }

  disconnectedCallback() {
    clearInterval(this.refreshInterval);
  }

  // "09:00-12:00" becomes { start: 540, end: 720 } (minutes since midnight)
  parseRange = (range) => {
    const [start, end] = range.split('-').map(this.toMinutes);
    return Number.isFinite(start) && Number.isFinite(end) ? { start, end } : null;
  }

  toMinutes = (time) => {
    const [hours, minutes] = (time || '').split(':').map((part) => parseInt(part, 10));
    return hours * 60 + (minutes || 0);
  }

  // Current date in the store time zone, whatever the visitor's time zone is
  getStoreNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: this.dataset.timezone || 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date()).reduce((result, part) => ({ ...result, [part.type]: part.value }), {});

    const weekDayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);

    return {
      isoDate: `${parts.year}-${parts.month}-${parts.day}`,
      weekDay: weekDayIndex,
      minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10),
    };
  }

  isOpen = () => {
    const { isoDate, weekDay, minutes } = this.getStoreNow();

    if (this.closedDates.includes(isoDate) || !this.openWeekDays.includes(weekDay)) {
      return false;
    }

    const ranges = this.dayRanges.size > 0 ? this.dayRanges.get(weekDay) || [] : this.openingRanges;
    return ranges.some(({ start, end }) => minutes >= start && minutes < end);
  }

  render = () => {
    const open = this.isOpen();

    this.textElement.textContent = open ? this.dataset.openLabel : this.dataset.closedLabel;
    this.dotElement.classList.toggle('wq-footer-stores__dot--open', open);
    this.hidden = false;
  }
}

if (!window.customElements.get('wq-store-status')) {
  window.customElements.define('wq-store-status', StoreStatus);
}
